@switch (type()) {
    @case (EntityAttributesInputType.STRING) {
        @if (columnNamesWithReference().includes(attribute().key)) {
            <app-select
                emptyOptionLabel="mapFilter.noValueSuggested"
                [additionalClasses]="isValueEdited() ? 'border-solid border-2 border-custom-blue' : ''"
                [defaultValue]="defaultAttributeOption"
                [enableSearch]="false"
                [isDisabled]="disabled()"
                [isRequired]="!informationSchemaTable()?.isNullable && !control()?.value"
                [label]="label() ?? attribute().key"
                [labelTooltip]="labelTooltip()"
                [optionLoading]="optionLoading()"
                [options]="attributeOptions()"
                [selectedOptions]="selectedAttributeOption()"
                [sortOptions]="false"
                [valueTooltip]="tooltipValue()"
                (blur)="setStandardizedAttributesValue($event)"
                (inputFocus)="initAttributeValues()"
                (resetValue)="resetStandardizedAttributeValue()"
                (scrollEnd)="fetchNextPage()"
                (search)="search($event)" />
        } @else {
            <app-input-text
                [additionalClasses]="isValueEdited() ? '!border-custom-blue' : ''"
                [disabled]="disabled()"
                [errors]="errorMessages()"
                [inputFormControl]="control()!"
                [label]="label() ?? attribute().key"
                [labelTooltip]="labelTooltip()"
                [placeholder]="String(control()?.value)"
                [valueTooltip]="tooltipValue()"
                (onValueChange)="setValueAndErrorsMessage($event)" />

            @if (isReferredLayerNotFound()) {
                <span class="text-sm text-gray-500">{{ 'editMode.noReferenceLayerInProject' | transloco }}</span>
            }
        }
    }
    @case (EntityAttributesInputType.NUMBER) {
        <app-input-number
            [additionalClasses]="isValueEdited() ? '!border-custom-blue' : ''"
            [disabled]="disabled()"
            [errors]="errorMessages()"
            [inputFormControl]="control()!"
            [label]="label() ?? attribute().key"
            [labelTooltip]="labelTooltip()"
            [placeholder]="String(control()?.value)"
            [valueTooltip]="tooltipValue()"
            (onValueChange)="setValueAndErrorsMessage($event)" />
    }
    @case (EntityAttributesInputType.BOOLEAN) {
        <div class="flex flex-col gap-2 items-baseline">
            <label
                class="font-normal text-base"
                [matTooltip]="labelTooltip()"
                [matTooltipDisabled]="!labelTooltip()">
                {{ label() ?? attribute().key }}
            </label>
            <app-select
                class="w-full"
                [canClear]="this.informationSchemaTable()?.isNullable ?? false"
                [defaultValue]="defaultOptionValue"
                [isDisabled]="disabled()"
                [options]="options"
                (optionSelected)="selectBooleanOption($event)" />
        </div>
    }
    @case (EntityAttributesInputType.DATE) {
        <div class="flex flex-col gap-0.5 items-baseline">
            <label class="font-normal text-base">
                <ng-container [ngTemplateOutlet]="attributeLabel" />
            </label>

            <div
                class="w-full border border-gray-300 rounded"
                [class.!border-custom-blue]="isValueEdited()">
                <app-entity-table-date-cell
                    [context]="EntityTableDateCellContext.DETAIL"
                    [edited]="isValueEdited()"
                    [info]="attributeInfo()!"
                    [value]="control()?.value"
                    (valueChange)="setValueAndErrorsMessage($event)" />
            </div>
        </div>
    }
    @case (EntityAttributesInputType.TIMESTAMPTZ) {
        <div class="flex flex-col gap-0.5 items-baseline">
            <label class="font-normal text-base">
                <ng-container [ngTemplateOutlet]="attributeLabel" />
            </label>

            <div
                class="w-full border border-gray-300 rounded flex-1"
                [class.!border-custom-blue]="isValueEdited()">
                <app-entity-table-date-hour-cell
                    [context]="EntityTableDateCellContext.DETAIL"
                    [edited]="isValueEdited()"
                    [info]="attributeInfo()!"
                    [value]="control()?.value"
                    (valueChange)="setValueAndErrorsMessage($event)" />
            </div>
        </div>
    }
}
<ng-template #attributeLabel>
    <span
        [matTooltip]="labelTooltip()"
        [matTooltipDisabled]="!labelTooltip()">
        {{ label() ?? attribute().key }}
    </span>
</ng-template>
